
<template>
<!--  <account-view></account-view>-->
  <luma-empty>
    <b-card>
      <b-button class="col-12"
                @click="$bvModal.show('create_user')"
                variant="outline-success">
        Benutzer erstellen
      </b-button>
    </b-card>
    <b-modal id="create_user">
      <b-form-group class="m-4">
        <b-form-group           label-cols-sm="3"
                                label="Name"
                                label-align-sm="right">
          <b-form-input v-model="user_data.username"></b-form-input>
        </b-form-group>
      </b-form-group>
      <email-input @emitEmail="emitEmail"></email-input>
      <password-input @emitPassword="emitPassword"></password-input>
      <luma-account-rights @emitRights="emitRights"></luma-account-rights>
      <template v-slot:modal-footer>
        <b-button @click="commit_changes()">
          Speichern
        </b-button>
        <b-button @click="$bvModal.hide('create_user')">
          Abbrechen
        </b-button>
      </template>
    </b-modal>
    <luma-account-list></luma-account-list>
  </luma-empty>
</template>
<script>
    import AccountView from "./details_account/account-view-v0";
    import LumaAccountList from "./details_account/luma-account-list";
    import LumaEmpty from "../../layout/LumaEmpty";
    import LumaAccountRights from "./details_account/luma-account-rights";
    import {GetPermissions} from "@/store/models/account/account_get_permissions";
    import LumaUserEmail from "./details_account/luma-user-email";
    import EmailInput from "./email-input";
    import PasswordInput from "./password-input";
    import axios from "@/store/vue-axios/axios"

    export default {
        name: "account-subuser",
        components: {
          PasswordInput,
          EmailInput,
          LumaUserEmail,
          LumaAccountRights,
          LumaEmpty,
          LumaAccountList,
          AccountView},
        data:()=>({
          user_data:{}
        }),
        methods:{
          emitRights(val){
            console.log('SAVED',val)
            this.user_data.permissions = val.permissions
          },
          emitPassword(val){
            this.user_data.password = val
          },
          emitEmail(val){
            this.user_data.email = val
          },
          commit_changes(){
            console.log('MODAL-COMMIT:::',this.user_data)
            this.$bvModal.hide('create_user')
            const req = axios.post("/account/users/create",this.user_data)
          }
        },
        created() {
          GetPermissions.fetchPermissions()
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/account-subuser.vue